import styles from "./Brand.module.css";

/**
 * The Kart·Centrum Admin product lockup.
 * Matches docs/mocks/assets/styles.css `.brand .name` structure.
 */
export function Brand() {
  // Injected by the backend at serve time; absent on the Vite dev server.
  const version = window.__KARTIS_CONFIG__?.version ?? "dev";

  return (
    <div className={styles.brand}>
      <div className={styles.name}>
        Kart<b>·</b>Centrum
        <small>
          Vouchery <span className={styles.version}>· {version}</span>
        </small>
      </div>
    </div>
  );
}
